import { Link } from 'react-router-dom';
import iconLogoImg from '../images/icon_logo.jpg';
import './Home.css';

function AugpUsa() {
  const engagementPillars = [
    { title: 'Civic Leadership Programs', desc: 'Training youth and community advocates in SDG leadership and civic action.' },
    { title: 'International Donor Coordination', desc: 'Structuring financial & donor channels for global infrastructural projects.' },
    { title: 'Human Rights & Peace Symposia', desc: 'Hosting public forums promoting dignity, equity, and peaceful governance.' },
    { title: 'Cross-Border NGO Alliances', desc: 'Bridging US philanthropies with grassroots projects in Asia and developing regions.' }
  ];

  return (
    <div className="page-shell">
      <div className="page-intro un-hero" style={{ padding: '36px', borderRadius: '24px', marginBottom: '36px' }}>
        <span className="un-pill">US Headquarters & Partnership Platform</span>
        <h1 className="page-title" style={{ marginTop: '8px', color: '#0c2f4d', fontSize: '2.5rem', fontWeight: '800' }}>
          AUGP USA
        </h1>
        <p className="page-subtitle" style={{ fontSize: '1.08rem', lineHeight: '1.75' }}>
          Connecting global development goals with civic action, educational advancement, and international cooperation across the United States.
        </p>
      </div>

      <div className="content-wrap contact-layout">
        <section className="content-panel info-card-hover" style={{ padding: '32px' }}>
          <h3 style={{ color: '#0c2f4d', marginTop: 0, fontSize: '1.6rem', fontWeight: '700' }}>Strategic Mission in the USA</h3>
          <p style={{ fontSize: '1.02rem', lineHeight: '1.8', color: '#405a73' }}>
            AUGP USA serves as a non-profit strategic partnership platform in Delaware, USA.
            It works in concert with UNGDO to facilitate academic exchanges, civic leadership forums, international donor coordination, and sustainable development initiatives.
          </p>

          <h3 style={{ color: '#0c2f4d', marginTop: '32px', fontSize: '1.5rem', fontWeight: '700' }}>Key Engagement Pillars</h3>
          
          {/* Animated Pillars Grid */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: '18px', marginTop: '20px' }}>
            {engagementPillars.map((pillar, idx) => (
              <div key={idx} className="funding-item" style={{ flexDirection: 'column', alignItems: 'flex-start', padding: '20px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '8px' }}>
                  <span className="funding-check">✓</span>
                  <strong style={{ color: '#0c2f4d', fontSize: '1rem' }}>{pillar.title}</strong>
                </div>
                <p style={{ margin: 0, fontSize: '0.9rem', color: '#405a73', lineHeight: '1.6' }}>{pillar.desc}</p>
              </div>
            ))}
          </div>
        </section>

        <aside>
          <div className="info-card info-card-hover" style={{ marginBottom: '24px', textAlign: 'center' }}>
            <img src={iconLogoImg} alt="UNGDO Logo" style={{ maxWidth: '80px', borderRadius: '10px', marginBottom: '14px' }} />
            <h3 style={{ color: '#0c2f4d', margin: '0 0 12px' }}>US Office Contact</h3>
            <p style={{ fontSize: '0.92rem', color: '#405a73', margin: '0 0 8px' }}>
              <strong>Head Office:</strong> Delaware, USA
            </p>
            <p style={{ fontSize: '0.92rem', color: '#009edb', margin: '0 0 18px', fontWeight: '600' }}>
              <strong>Email:</strong> info@ungdo.org
            </p>
            <Link to="/contact" className="primary-button" style={{ width: '100%', textAlign: 'center', display: 'block', textDecoration: 'none' }}>
              Contact AUGP USA →
            </Link>
          </div>
        </aside>
      </div>
    </div>
  );
}

export default AugpUsa;
